import { useMemo } from 'react'

import PlainInput, { type PlainInputProps } from '../plain-input'
import { defaultPredefinedParams, getPredefinedParams } from './mask-predefined'
import { maskType } from './mask-types'

export type PlainInputMaskedCustomProps = {
  value?: string
  onValue?: (value: string) => void
  predefinedMaskType?:
    | (typeof maskType)['MASK_TIME_CUSTOM']
    | (typeof maskType)['MASK_WEEKDAY_TIME']
    | (typeof maskType)['MASK_WEEKDAY_SHORT_TIME']
} & Omit<PlainInputProps, 'value'>

export const PlainInputMaskedCustom = ({
  value,
  onValue,
  predefinedMaskType,
  ...other
}: PlainInputMaskedCustomProps) => {
  const { format } = useMemo(() => {
    return predefinedMaskType ? getPredefinedParams(predefinedMaskType) : defaultPredefinedParams
  }, [predefinedMaskType])

  if (typeof format === 'string') {
    throw new Error(
      'mask-predefined.ts: format must be only a function for MASK_TIME_CUSTOM, MASK_WEEKDAY_TIME or MASK_WEEKDAY_SHORT_TIME',
    )
  }

  const handleValue = (value: string) => {
    onValue?.(format(value))
  }

  return <PlainInput value={value && format(value)} onValue={handleValue} {...other} />
}
